/**

import {} from '@corefront/constants/messages'

 */
export const CHAT_THREAD_CLASS = 'cf-chat-thread'

export const MESSAGE_TYPE = {
  FOLLOWUP: 'followup',
  PRESCRIPTION_CONFIRMATION: 'prescription_confirmation',
  PRESCRIPTION_FOLLOWUP: 'prescription_followup',
  TEXT: 'text',
  ATTACHMENT: 'attachment',
  FORWARD_MESSAGE: 'forward_message',
}

export const MESSAGE_ACTION = {
  SENT: 'SENT',
  UPDATED: 'UPDATED',
}

export const MESSAGE_ROLES = {
  PATIENT: 'PATIENT',
  ADMIN: 'ADMIN',
  DOCTOR: 'DOCTOR',
  SUPER_ADMIN: 'SUPER ADMIN',
}

export const MESSAGE_TYPES = {
  MESSAGE: 'MESSAGE',
  NOTE: 'NOTE',
}

export const MESSAGE_SEND_STATUS = {
  PENDING: 'PENDING',
  SENT: 'SENT',
  FAILED: 'FAILED',
}

export const MESSAGE_COMMUNICATION_ROLE = {
  SENDER: 'SENDER',
  RECEIVER: 'RECEIVER',
}

export const MESSAGE_EVENT_CATEGORY = {
  ADMIN_UPDATE: 'Admin Update',
  ADMIN_UPDATED: 'Admin Updated',
  INFORMATION_UPDATE: 'Information Update',
  DOCTOR_REASSIGNED: 'Doctor Reassigned',
  REFUND: 'Refund',
  SUPPORT_INTERACTION: 'Support Interaction',
  NOTES: 'Notes',
  SMS: 'SMS',
  INTERCOM: 'Intercom',
  JUST_CALL: 'JustCall',
  EVENT: 'Event',
  ONBOARDING: 'Onboarding',
  ORDERS: 'Orders',
  PLATFORM_FEE: 'Platform Fee',
  PATIENT: 'Patient',
  PATIENT_INFO_EDIT: 'Patient Info Edit',
  ACCOUNT_UNBANNED: 'Account Unbanned',
  ACCOUNT_UNBANNED_2: 'Account UnBanned',
  ACCOUNT_BANNED: 'Account Banned',
  FOLLOW_UP: 'Follow Up',
  FORWARDED_MESSAGE: 'FORWARDED_MESSAGE',
}

export const MESSAGE_EVENT_NAME = {
  INCOMING: 'Incoming',
  OUTGOING: 'Outgoing',
  FOLLOW_UP_CREATED: 'Follow Up Created',
  FOLLOW_UP_UPDATED: 'Follow Up Updated',
  PATIENT_CANCELLED: 'Patient Cancelled',
  TREATMENT_SHIPPED: 'Treatment Shipped',
  PAYMENT_FAILED: 'Payment Failed',
  EMAIL_UPDATED: 'Email Updated',
  ADDRESS_VERIFICATION: 'Address Verification',
  ACCOUNT_CREATED: 'Account Created',
  VISIT_STARTED: 'Visit Started',
  QUESTIONNAIRE_COMPLETED: 'Questionnaire Completed',
  TREATMENT_CHOSEN: 'Treatment Chosen',
  VERIFICATION_STARTED: 'Verification Started',
  ID_UPLOADED: 'ID Uploaded',
  PHOTO_UPLOADED: 'Photo Uploaded',
  CHECKOUT_STARTED: 'Checkout Started',
  ID_UPLOAD_SKIPPED: 'ID Upload Skipped',
  PHOTO_UPLOAD_SKIPPED: 'Photo Upload Skipped',
  IDENTITY_VERIFICATION_DENIED: 'Identity Verification: Denied',
  FOLLOW_UP_CANCELLED: 'Follow Up Cancelled',
  CHECKOUT_COMPLETE: 'Checkout Complete',
  ONBOARDING_COMPLETED: 'Onboarding Completed',
  PATIENT_ACCEPTED: 'Patient Accepted',
  IDENTITY_VERIFICATION_ACCEPTED: 'Identity Verification: Accepted',
  FOLLOW_UP_STARTED: 'Follow Up Started',
  FOLLOW_UP_COMPLETED: 'Follow Up Completed',
  FOLLOW_UP_SENT: 'Follow Up Sent',
  DOCTOR_SENT_A_MESSAGE: 'Dr Sent a Message',
  PATIENT_SENT_A_MESSAGE: 'Patient Sent a Message',
  PATIENT_MESSAGED_DOCTOR: 'Patient Messaged Doctor',
  PHOTO_UPDATED: 'Photo Updated',
  ID_UPDATED: 'ID Updated',
  NOTE: 'Note',
  REASSIGNED: 'Reassigned',
  PAYMENT_CLEARED: 'Payment Cleared',
  CALL_SCHEDULED: 'Call Scheduled',
  DOCTOR_REQUEST_COMPLETED: 'Doctor Request Completed',
}

export const MESSAGE_EVENT_KEYS = {
  TREATMENT_SHIPPED: 'treatmentShipped',
}

export const MESSAGE_PLATFORM = {
  INTERCOM: 'INTERCOM',
}

export const CHAT_TYPE = {
  ADMIN: 'ADMIN',
  PATIENT: 'PATIENT',
  NOTES: 'NOTES',
  EVENT: 'EVENT',
}

export const MESSAGE_ENTRY_TYPES = {
  PATIENT_TRANSFER: 'PATIENT_TRANSFER',
  EVENT: 'EVENT',
  ATTACHMENT: 'ATTACHMENT',
  MESSAGE: 'MESSAGE',
  JUST_CALL: 'JUST_CALL',
}

export const MESSAGE_JUST_CALL_TYPES = {
  SMS_SENT_RECEIVED: 'sms.sent_received',
  CALL_COMPLETED: 'call.completed',
}

export const MESSAGE_JUST_CALL_DIRECTIONS = {
  OUTGOING: 'Outgoing',
  INCOMING: 'Incoming',
}

export const FAILED_MESSAGE_TYPE = {
  ADMIN_CHAT: 'admin-patient-chat-message',
  ADMIN_MESSAGE: 'admin-message',
}

export const MESSAGE_CATEGORY = {
  ALL: 'ALL',
  OPEN: 'OPEN',
  DISMISSED: 'DISMISSED',
  UNASSIGNED: 'UNASSIGNED',
  ASSIGNED: 'ASSIGNED',
}